import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import IndentSummaryPanel from "../../../MasterDashboard/panels/IndentSummaryPanel";
import useViewOnlyAccess from "../../../../hooks/useViewOnlyAccess";
import { useIndentTracking } from "../../hooks/useIndentTracking";

const Irdashboard = () => {
  const { isRestricted, handleRestrictedClick } = useViewOnlyAccess("indent", "lorri_indent_request", true);
  const { trackIndentEvent } = useIndentTracking();

  useEffect(() => {
    document.title = "LoRRI Indent - Indent Request Dashboard";
    ReactGA.send("LoRRI Indent - Indent Request Dashboard");
    trackIndentEvent("indent request dashboard", "user has visited indent request dashboard");
  }, []);

  return <IndentSummaryPanel viewOnly={isRestricted} onRestrictedClick={() => handleRestrictedClick()} />;
};

export default Irdashboard;
